import { getWalletBookWallet } from '@dynamic-labs/wallet-book';
import WalletConnect from './walletConnect/walletConnect.js';
import WalletConnectV2 from './walletConnect/walletConnectV2.js';

const getMobileOrInjectedWallet = ({ evmNetworks, injectedWallet, isWalletConnectV2 = false, walletConnectName, }) => {
    var _a, _b;
    if (injectedWallet.isInstalledOnBrowser()) {
        return injectedWallet;
    }
    else {
        const wallet = getWalletBookWallet(walletConnectName);
        if (isWalletConnectV2 && ((_b = (_a = wallet.walletConnect) === null || _a === void 0 ? void 0 : _a.sdks) === null || _b === void 0 ? void 0 : _b.includes('sign_v2'))) {
            return new WalletConnectV2({
                evmNetworks,
                walletName: walletConnectName,
            });
        }
        else {
            return new WalletConnect({
                evmNetworks,
                walletName: walletConnectName,
            });
        }
    }
};

export { getMobileOrInjectedWallet };
